import { useEffect, useMemo } from 'react'

type SelectOption = { label: string; value: string }

export const useProgramSelection = (
  programs: SelectOption[] | undefined,
  selectedProgramId: string | undefined,
  formProgramId: string,
  setFieldValue: (field: string, value: string) => void
) => {
  const selectedProgramOption = useMemo(() => {
    return programs?.find(p => p.value === formProgramId)
  }, [programs, formProgramId])

  const programsWithSelected = useMemo(() => {
    if (!programs || !selectedProgramOption) return programs

    const programExists = programs.some(p => p.value === selectedProgramOption.value)

    if (!programExists) {
      return [selectedProgramOption, ...programs]
    }

    return programs
  }, [programs, selectedProgramOption])

  useEffect(() => {
    if (selectedProgramId && !formProgramId) {
      setFieldValue('selectedProgramId', selectedProgramId)
    }
  }, [selectedProgramId, formProgramId, setFieldValue])

  return {
    selectedProgramOption,
    programsWithSelected
  }
}
